module.exports = __webpack_public_path__ + "static/img/err.f3116fa5.jpg";